import { Modal, Typography } from 'antd';

import { useLeadCardContext } from '@app/components/LeadCard/context';
import { FooterSkeleton } from '@app/components/LeadCard/ui/FooterSkeleton';
import { MessageComposer } from '@app/components/LeadCard/ui/MessageComposer';
import { TasksPreview } from '@app/components/LeadCard/ui/TasksPreview';

import type { FC } from 'react';

import './MainFooter.scss';

const { Text } = Typography;

export const MainFooter: FC = () => {
  const { isFooterLoading, footerTasks, footerConfirmation, answerTimer } =
    useLeadCardContext();

  return (
    <footer className="MainFooter">
      {isFooterLoading ? (
        <FooterSkeleton />
      ) : (
        <>
          {answerTimer.isVisible && (
            <div className="MainFooter__answer-timer" role="status">
              {answerTimer.text}
            </div>
          )}
          <TasksPreview tasks={footerTasks} />
          <MessageComposer />
          <Modal
            title={footerConfirmation.title}
            open={footerConfirmation.isOpen}
            okText={footerConfirmation.okText}
            cancelText={footerConfirmation.cancelText}
            onOk={footerConfirmation.onConfirm}
            onCancel={footerConfirmation.onCancel}
            okButtonProps={{
              danger: footerConfirmation.isDanger,
              loading: footerConfirmation.isLoading,
            }}
            cancelButtonProps={{
              disabled: footerConfirmation.isLoading,
            }}
            destroyOnHidden
          >
            <Text>{footerConfirmation.text}</Text>
          </Modal>
        </>
      )}
    </footer>
  );
};
